module.exports = __webpack_public_path__ + "static/media/alis04.98603fe7.jpg";